// PopupComponent.jsx
import React from "react";
import "./modalComponent.scss";

const Modal = ({ type, show, onClose, buttons, onSave, header, children, saveLabel, saveDisabled }) => {
//   if (!show) return null; // hide when show = false


    return (
        <div
            className={
                "modalContainer " +
                (show ? "show " : "") +
                (type === "error" ? "error " : "") +
                (type === "success" ? "success " : "")
            }
            onClick={(e) => e.stopPropagation()}
        >
            <div className="modalOverlay" onClick={onClose}></div>
            <div className="modalInner">
                {/* Header */}
                <div className="modalHeader">
                    <span>
                        { (type === "error") ? <i className="fa fa-exclamation-triangle me-2" aria-hidden="true"></i> : "" }
                        { (type === "success") ? <i className="fa fa-check me-2" aria-hidden="true"></i> : "" }
                        {header || "Custom Modal"}
                    </span>

                    <div className="closeModal" onClick={onClose}>
                        <i className="fa fa-times"></i>
                    </div>
                </div>

                {/* Body */}
                <div className="modalBody">
                    {children}
                </div>

                {/* Footer */}
                {
                    buttons ?
                    <div className="modalFooter">
                        {/* cancel button */}
                        <button className="bouncy-button white small" onClick={onClose}>
                            <span>Cancel</span>
                        </button>

                        {/* action button */}
                        <button
                            className={
                                "bouncy-button small " +
                                (type === "error" ? "red " : "") +
                                (type === "success" ? "green " : "")
                            }
                            disabled={!!saveDisabled}
                            onClick={onSave}
                        >
                            <span>{saveLabel || "Save"}</span>
                        </button>
                    </div> : ""
                }
            </div>
        </div>
    );
};

export default Modal;
